module.exports = __webpack_public_path__ + "img/header-weddingRingsSlim.772210c.webp";